// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-cell {
  line-height: 1 !important;
  padding: 0.25rem 0.75rem !important;
  border-right: 1px solid #d3d3d3c2;
}

/* ===== Technician PACS list — denser cells to match the Orders page =====
   Scoped to .pacs-tech-dense (added only for technicians) so the other PACS
   roles keep their default spacing. The :not() exclusions preserve the special
   padding on the checkbox, leading icon columns and the reporting-status dot. */

.pacs-tech-dense .pacs-ag-grid .ag-cell:not([col-id="__checkbox__"]):not([col-id="notes_icon"]):not([col-id="info_icon"]):not([col-id="series_info_icon"]):not([col-id="history_icon"]):not([col-id="live_report_status"]) {
  padding: 0 8px;
}

.pacs-tech-dense .pacs-ag-grid .ag-header-cell:not([col-id="__checkbox__"]) {
  padding-left: 8px;
  padding-right: 8px;
}

/* Let longer headers (e.g. "Received Date") wrap rather than widen the column. */

.pacs-tech-dense .pacs-ag-grid .ag-header-cell-label {
  white-space: normal;
  line-height: 1.1;
}

/* Special styling for patient name column to align with header */

.col-pat-name {
  padding: 0 !important;
  margin-left: -0.1875rem !important;
}

/* Selection column styling */

.ant-table-selection-column {
  width: 3.75rem !important;
  min-width: 3.75rem !important;
  text-align: center !important;
}

.ant-table-selection-column .ant-checkbox-wrapper {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
      -ms-flex-pack: center !important;
          justify-content: center !important;
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;
}

/* Header selection checkbox centering */

.ant-table-thead .ant-table-selection-column {
  text-align: center !important;
}

.ant-table-thead .ant-table-selection-column .ant-checkbox-wrapper {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
      -ms-flex-pack: center !important;
          justify-content: center !important;
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;
}

.ant-table-thead .ant-table-selection-column .ant-table-selection {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
      -ms-flex-pack: center !important;
          justify-content: center !important;
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;
}

/* ===== PACS — Filter Section (page-specific) ===== */

.pacs-filters-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.pacs-field {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  min-width: 0;
}

.pacs-field--name      { width: 9.6875rem; }

.pacs-field--id        { width: 7.1875rem; }

.pacs-field--acc       { width: 6.5625rem; }

.pacs-field--ref       { width: 8.75rem; }

.pacs-field--body      { width: 9.0625rem; }

.pacs-field--status    { width: 8.4375rem; }

.pacs-field--center    { width: 7.5rem; }

.pacs-field--hisstatus { width: 7.5rem; }

.pacs-field--reportedby { width: 10rem; }

.pacs-field--assignedto { width: 10rem; }

.pacs-field--date      { width: auto; }

/* Study-date selector with the quick-preset chips (1D, 2D, 1W ...) beside it. */

.date-with-presets {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.5rem;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.pacs-filters-row .date-with-presets .ant-picker {
  width: 18.125rem !important;
}

.pacs-filters-row .ant-input,
.pacs-filters-row .ant-picker,
.pacs-filters-row .ant-select {
  width: 100% !important;
}

.ant-modal-body {
  /* height: 75vh; */
  min-height: 30vh;
}

td.emergency {
  background-color: #fca428bf;
  /* color: white; */
}

.save-filter-modal {
  -webkit-transform-origin: top center !important;
          transform-origin: top center !important;
}

.quick-filters {
  background: #2d343c;
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  font-weight: bold;
  cursor: pointer;
}

.draggable-header:hover {
  /* Only cursor change, no background styling */
}

.draggable-header:active {
  background-color: #e6f7ff;
  border: 0.0625rem dashed #1890ff;
}

/* Add visual feedback during drag */

.ant-table-thead > tr > th {
  position: relative;
}

.ant-table-thead > tr > th:hover .draggable-header {
  /* Only cursor change, no background styling */
}

.upload-pdf-box {
  border: 2px dashed #7D48B0;
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  background-color: #f5f5f5;
  opacity: 0.6;
}

.upload-pdf-box.active {
  background-color: #f9f5ff;
  opacity: 1;
}

.upload-pdf-button {
  height: 2.5rem;
  font-size: 1rem;
  border-radius: 0.375rem;
  background-color: #7D48B0;
  color: white;
  border: none;
  cursor: pointer;
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.upload-pdf-button.active {
  background-color: #d9d9d9;
  cursor: not-allowed;
}

.file-box-text{
  font-weight: 500;
  font-size: 1rem;
  display: block;
  margin-bottom: 0.5rem;
}

.pacs-priority-pills-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 0.5rem;
}

.pacs-priority-pills-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 0.5rem;
}

.pacs-priority-pill {
  padding: 0.25rem 0.75rem;
  height: 1.875rem;
  border: 1px solid #D1D5DB;
  border-radius: 0.5rem;
  background: #FFFFFF;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.pacs-priority-pill:hover {
  border-color: #9CA3AF;
  background: #F9FAFB;
}

.pacs-priority-pill.selected {
  background: #F7EFFF;
  border: 1px solid #7D48B0;
  color: #400A73;
}

.pacs-priority-pill-emergency {
  width: 7.5rem; /* Fixed width for large screens */
}

.pacs-priority-pill-rereported {
  width: 7.5rem; /* Fixed width for large screens */
}

/* For medium and small screens (≤1200px): Make pills take full width */

@media (max-width: 1200px) {
  .pacs-priority-pill-emergency,
  .pacs-priority-pill-rereported {
    width: 100% !important;
  }
}

/* Action Icons Styling - Better clickable area */

.action-icon-button {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
  min-width: 24px;
  min-height: 24px;
}

.action-icon-button:hover {
  /* Tinted hover pill matching the icon's hue (set per-icon via --ai-hover);
     falls back to a neutral gray for any icon that doesn't set the var. */
  background-color: var(--ai-hover, #eef1f5);
}

.action-icon-button.disabled {
  /* The flat icon component applies its own grayscale + fade when disabled,
     so the wrapper only needs the not-allowed cursor (no extra opacity). */
  cursor: not-allowed;
}

.action-icon-button.disabled:hover {
  background-color: transparent;
}

.patient-orders-table .ant-table-pagination,
.patient-orders-table .ant-pagination {
  -webkit-box-pack: end !important;
      -ms-flex-pack: end !important;
          justify-content: flex-end !important;
  float: right !important;
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./pages/pacs/pacs.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;;;gFAGgF;;AAChF;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iFAAiF;;AACjF;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iEAAiE;;AACjE;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,6BAA6B;;AAC7B;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,mCAAkC;MAAlC,gCAAkC;UAAlC,kCAAkC;EAClC,oCAA8B;MAA9B,iCAA8B;UAA9B,8BAA8B;AAChC;;AAEA,wCAAwC;;AACxC;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,mCAAkC;MAAlC,gCAAkC;UAAlC,kCAAkC;EAClC,oCAA8B;MAA9B,iCAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,mCAAkC;MAAlC,gCAAkC;UAAlC,kCAAkC;EAClC,oCAA8B;MAA9B,iCAA8B;UAA9B,8BAA8B;AAChC;;AAEA,sDAAsD;;AACtD;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,YAAY;AACd;;AAEA,yBAAyB,gBAAgB,EAAE;;AAC3C,yBAAyB,gBAAgB,EAAE;;AAC3C,yBAAyB,gBAAgB,EAAE;;AAC3C,yBAAyB,cAAc,EAAE;;AACzC,yBAAyB,gBAAgB,EAAE;;AAC3C,yBAAyB,gBAAgB,EAAE;;AAC3C,yBAAyB,aAAa,EAAE;;AACxC,yBAAyB,aAAa,EAAE;;AACxC,0BAA0B,YAAY,EAAE;;AACxC,0BAA0B,YAAY,EAAE;;AACxC,yBAAyB,WAAW,EAAE;;AAEtC,gFAAgF;;AAChF;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,+CAAuC;UAAvC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,oCAAoC;;AACpC;EACE,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,4BAAoB;EAApB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;AACd;;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,wBAAgB;EAAhB,gBAAgB;AAClB;;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iCAAyB;EAAzB,yBAAyB;EACzB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa,EAAE,kCAAkC;AACnD;;AAEA;EACE,aAAa,EAAE,kCAAkC;AACnD;;AAEA,uEAAuE;;AACvE;EACE;;IAEE,sBAAsB;EACxB;AACF;;AAEA,iDAAiD;;AACjD;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAAsC;EAAtC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;0EACwE;EACxE,0CAA0C;AAC5C;;AAEA;EACE;2EACyE;EACzE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,gCAAoC;MAApC,6BAAoC;UAApC,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":[".ant-table-cell {\r\n  line-height: 1 !important;\r\n  padding: 0.25rem 0.75rem !important;\r\n  border-right: 1px solid #d3d3d3c2;\r\n}\r\n\r\n/* ===== Technician PACS list — denser cells to match the Orders page =====\r\n   Scoped to .pacs-tech-dense (added only for technicians) so the other PACS\r\n   roles keep their default spacing. The :not() exclusions preserve the special\r\n   padding on the checkbox, leading icon columns and the reporting-status dot. */\r\n.pacs-tech-dense .pacs-ag-grid .ag-cell:not([col-id=\"__checkbox__\"]):not([col-id=\"notes_icon\"]):not([col-id=\"info_icon\"]):not([col-id=\"series_info_icon\"]):not([col-id=\"history_icon\"]):not([col-id=\"live_report_status\"]) {\r\n  padding: 0 8px;\r\n}\r\n\r\n.pacs-tech-dense .pacs-ag-grid .ag-header-cell:not([col-id=\"__checkbox__\"]) {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n}\r\n\r\n/* Let longer headers (e.g. \"Received Date\") wrap rather than widen the column. */\r\n.pacs-tech-dense .pacs-ag-grid .ag-header-cell-label {\r\n  white-space: normal;\r\n  line-height: 1.1;\r\n}\r\n\r\n/* Special styling for patient name column to align with header */\r\n.col-pat-name {\r\n  padding: 0 !important;\r\n  margin-left: -0.1875rem !important;\r\n}\r\n\r\n/* Selection column styling */\r\n.ant-table-selection-column {\r\n  width: 3.75rem !important;\r\n  min-width: 3.75rem !important;\r\n  text-align: center !important;\r\n}\r\n\r\n.ant-table-selection-column .ant-checkbox-wrapper {\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n}\r\n\r\n/* Header selection checkbox centering */\r\n.ant-table-thead .ant-table-selection-column {\r\n  text-align: center !important;\r\n}\r\n\r\n.ant-table-thead .ant-table-selection-column .ant-checkbox-wrapper {\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.ant-table-thead .ant-table-selection-column .ant-table-selection {\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n}\r\n\r\n/* ===== PACS — Filter Section (page-specific) ===== */\r\n.pacs-filters-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 0.5rem;\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.pacs-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.pacs-field--name      { width: 9.6875rem; }\r\n.pacs-field--id        { width: 7.1875rem; }\r\n.pacs-field--acc       { width: 6.5625rem; }\r\n.pacs-field--ref       { width: 8.75rem; }\r\n.pacs-field--body      { width: 9.0625rem; }\r\n.pacs-field--status    { width: 8.4375rem; }\r\n.pacs-field--center    { width: 7.5rem; }\r\n.pacs-field--hisstatus { width: 7.5rem; }\r\n.pacs-field--reportedby { width: 10rem; }\r\n.pacs-field--assignedto { width: 10rem; }\r\n.pacs-field--date      { width: auto; }\r\n\r\n/* Study-date selector with the quick-preset chips (1D, 2D, 1W ...) beside it. */\r\n.date-with-presets {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.pacs-filters-row .date-with-presets .ant-picker {\r\n  width: 18.125rem !important;\r\n}\r\n\r\n.pacs-filters-row .ant-input,\r\n.pacs-filters-row .ant-picker,\r\n.pacs-filters-row .ant-select {\r\n  width: 100% !important;\r\n}\r\n\r\n\r\n.ant-modal-body {\r\n  /* height: 75vh; */\r\n  min-height: 30vh;\r\n}\r\n\r\ntd.emergency {\r\n  background-color: #fca428bf;\r\n  /* color: white; */\r\n}\r\n\r\n.save-filter-modal {\r\n  transform-origin: top center !important;\r\n}\r\n\r\n.quick-filters {\r\n  background: #2d343c;\r\n  color: white;\r\n  padding: 0.5rem 0.75rem;\r\n  border-radius: 0.25rem;\r\n  border-top-left-radius: 0.25rem;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n.draggable-header:hover {\r\n  /* Only cursor change, no background styling */\r\n}\r\n\r\n.draggable-header:active {\r\n  background-color: #e6f7ff;\r\n  border: 0.0625rem dashed #1890ff;\r\n}\r\n\r\n/* Add visual feedback during drag */\r\n.ant-table-thead > tr > th {\r\n  position: relative;\r\n}\r\n\r\n.ant-table-thead > tr > th:hover .draggable-header {\r\n  /* Only cursor change, no background styling */\r\n}\r\n\r\n.upload-pdf-box {\r\n  border: 2px dashed #7D48B0;\r\n  border-radius: 0.5rem;\r\n  padding: 2rem;\r\n  text-align: center;\r\n  transition: all 0.3s;\r\n  background-color: #f5f5f5;\r\n  opacity: 0.6;\r\n}\r\n.upload-pdf-box.active {\r\n  background-color: #f9f5ff;\r\n  opacity: 1;\r\n}\r\n\r\n.upload-pdf-button {\r\n  height: 2.5rem;\r\n  font-size: 1rem;\r\n  border-radius: 0.375rem;\r\n  background-color: #7D48B0;\r\n  color: white;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: 0.5s;\r\n}\r\n.upload-pdf-button.active {\r\n  background-color: #d9d9d9;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.file-box-text{\r\n  font-weight: 500;\r\n  font-size: 1rem;\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.pacs-priority-pills-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.pacs-priority-pills-row {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.pacs-priority-pill {\r\n  padding: 0.25rem 0.75rem;\r\n  height: 1.875rem;\r\n  border: 1px solid #D1D5DB;\r\n  border-radius: 0.5rem;\r\n  background: #FFFFFF;\r\n  font-family: Inter, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.875rem;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.pacs-priority-pill:hover {\r\n  border-color: #9CA3AF;\r\n  background: #F9FAFB;\r\n}\r\n\r\n.pacs-priority-pill.selected {\r\n  background: #F7EFFF;\r\n  border: 1px solid #7D48B0;\r\n  color: #400A73;\r\n}\r\n\r\n.pacs-priority-pill-emergency {\r\n  width: 7.5rem; /* Fixed width for large screens */\r\n}\r\n\r\n.pacs-priority-pill-rereported {\r\n  width: 7.5rem; /* Fixed width for large screens */\r\n}\r\n\r\n/* For medium and small screens (≤1200px): Make pills take full width */\r\n@media (max-width: 1200px) {\r\n  .pacs-priority-pill-emergency,\r\n  .pacs-priority-pill-rereported {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n/* Action Icons Styling - Better clickable area */\r\n.action-icon-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n  min-width: 24px;\r\n  min-height: 24px;\r\n}\r\n\r\n.action-icon-button:hover {\r\n  /* Tinted hover pill matching the icon's hue (set per-icon via --ai-hover);\r\n     falls back to a neutral gray for any icon that doesn't set the var. */\r\n  background-color: var(--ai-hover, #eef1f5);\r\n}\r\n\r\n.action-icon-button.disabled {\r\n  /* The flat icon component applies its own grayscale + fade when disabled,\r\n     so the wrapper only needs the not-allowed cursor (no extra opacity). */\r\n  cursor: not-allowed;\r\n}\r\n\r\n.action-icon-button.disabled:hover {\r\n  background-color: transparent;\r\n}\r\n\r\n.patient-orders-table .ant-table-pagination,\r\n.patient-orders-table .ant-pagination {\r\n  justify-content: flex-end !important;\r\n  float: right !important;\r\n  width: 100% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
